<template>
    <div id="deliverydate">
        <a-modal :title="$t('pubGicSet.exportPackageData')" v-model="visible" @ok="handleOk">
            <template slot="footer">
                <a-button type="primary" small="size" @click="saveDeliveryDate">{{ $t('generic.Export') }}</a-button>
            </template>
            <a-form :form="form">
                <a-form-item :label="$t('pubGicSet.orderCheckCompleteStartTime')"  v-bind="formItemLayout">
                    <a-date-picker show-time format="YYYY-MM-DD HH:mm:ss"  v-model="checkCompleteStartTime" />
                </a-form-item>
                <a-form-item :label="$t('pubGicSet.orderCheckCompleteEndTime')"  v-bind="formItemLayout">
                    <a-date-picker show-time format="YYYY-MM-DD HH:mm:ss"  v-model="checkCompleteEndTime"  />
                </a-form-item>
                <a-form-item :label="$t('pubGicSet.whetherToPrintOnlyCompletedOrders')"  v-bind="formItemLayout">
                    <a-checkbox style="margin-left: 10px" v-model="whetherToPrintOnlyCompletedOrders"></a-checkbox>
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>
<script>
    import moment from 'moment'
    import ajax from "../../../api/ajax";
    import api from "../../../api/url";
    import axios from "axios";
    export default{
        data(){
            return{
                checkCompleteStartTime:'',
                checkCompleteEndTime:'',
                whetherToPrintOnlyCompletedOrders:true,
                visible: false,
                form:  this.$form.createForm(this),
                uids: [],
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 10 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 14 }
                    }
                },
            }
        },
        methods:{
            moment,
            getCurrentData(){
                return new Date().toLocaleDateString();
            },
            getCurrentDataTime(){
                let d = new Date();
                return d;
            },
            handleOk(){
                this.visible = false
            },
            show(tt){
                this.visible = true;
                this.uids = tt;
                this.resetData();
            },
            saveDeliveryDate(){
                let params = {}
                let ajaxTypeName = api.EXPORTPACKAGEDATA
                    params = {
                        "uids": this.uids,
                        "checkCompleteStartTime": this.checkCompleteStartTime,
                        "checkCompleteEndTime": this.checkCompleteEndTime,
                        "whetherToPrintOnlyCompletedOrders": this.whetherToPrintOnlyCompletedOrders
                    }


                let ajaxurl = ajax.ajaxUrl();
                axios.post(ajaxurl + ajaxTypeName,params,{ responseType: 'blob'}).then(data => {
                    this.handleOk();
                    if (!data) {
                        return;
                    }
                    let type = data.data.type;
                    let that = this;
                    if( type.includes('application/json')){
                        let reader = new FileReader()
                        reader.onload = function (event) {
                            let content = reader.result
                            let msg = JSON.parse(content).msg
                            that.$customMessage.warning(msg);
                        }
                        reader.readAsText(data.data)
                        return
                    }else {
                        var blob = new Blob([data.data], {
                            type:
                                "APPLICATION/OCTET-STREAM"
                        });
                        var url = window.URL.createObjectURL(blob);
                        var aLink = document.createElement("a");
                        aLink.style.display = "none";
                        aLink.href = url;
                        aLink.setAttribute("download", "ExportDelivery.rar");
                        document.body.appendChild(aLink);
                        aLink.click();
                        document.body.removeChild(aLink); //下载完成移除元素
                        window.URL.revokeObjectURL(url); //释放掉blob对象

                        console.log(params)
                        // 再次请求，校验得出导出的信息，避免出现勾选的So Order掺杂着一部分不允许导出的
                        axios.post( ajaxurl + api.CHECKEXPORTSOORDERSTATUSNEW, params ).then(data => {
                            if(data.data.code == 200){
                                this.$message.success(data.data.msg);
                            } else {
                                this.$customMessage.warning(data.data.msg);
                            }
                        })
                    }
                })

            }, resetData() {
                this.whetherToPrintOnlyCompletedOrders = true;
                this.checkCompleteStartTime = moment(new Date().toLocaleDateString(), 'YYYY-MM-DD');
                this.checkCompleteEndTime = moment(new Date(), 'YYYY-MM-DD HH:mm:ss')
            }
        }
    }
</script>